import { Select } from './Select';
import { DEFAULT_DELIMITER } from './constants';

import type { MultiSelectProps } from './types';

export const MultiSelect = ({
  canBulkPaste = false,
  pasteDelimiter = DEFAULT_DELIMITER,
  ...props
}: MultiSelectProps) => {
  const customSelectProps = { canBulkPaste, pasteDelimiter }; // add more if needed
  return <Select isMulti {...props} {...customSelectProps} />;
};
